import ChatsPage from "./ChatsPage"
export default ChatsPage
